import { Component, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ApAlertService, ApBaseComponent } from 'webcommon/core-ui';
import { WebCommonStorageRepository } from 'webcommon/legacy-common';
import { FpMessagesRepository } from 'webcommon/webapi';
import { FpConfigurationService } from '../services/FpConfigurationService';
import { FpUserSettingsService } from '../services/FpUserSettingsService';

@Component({
  providers: [ ApAlertService, FpUserSettingsService ],
  selector: 'fp-shell',
  styleUrls: ['./fp-shell.component.less'],
  templateUrl: './fp-shell.component.html',
})
export class FPShellComponent extends ApBaseComponent implements OnInit {

  constructor(private fpConfigurationService: FpConfigurationService,
              private messagesRepository: FpMessagesRepository,
              private alertService: ApAlertService,
              private webCommonStorageRepository: WebCommonStorageRepository,
  ) {
    super();
  }

  Id = 'facility-portal';
  hasError = false;
  unreadMessageCount = 0;
  loadingUnreadMessageCounts = false;
  isActiveDirectoryUser = false;

  ngOnInit(): void {
    this.isActiveDirectoryUser = this.webCommonStorageRepository.getIsActiveDirectoryUser();
    this.fpConfigurationService.loadFpConfiguration();
    this.loadUnreadMessageCount();
  }

  private loadUnreadMessageCount(): void {
    this.loadingUnreadMessageCounts = true;
    this.messagesRepository.getUnreadMessageCount().pipe(
      finalize(() => this.onLoadUnreadMessageCountComplete()),
      this.takeUntilDestroy(),
    ).subscribe(
      (result) => this.onLoadUnreadMessageCountSuccess(result),
      () => this.onLoadUnreadMessageCountError(),
    );
  }

  private onLoadUnreadMessageCountComplete() {
    this.loadingUnreadMessageCounts = false;
  }

  private onLoadUnreadMessageCountSuccess(result: number) {
    this.unreadMessageCount = result;
    this.hasError = false;
  }

  private onLoadUnreadMessageCountError() {
    this.alert('An error has occurred and the number of unread messages could not be determined.');
    this.unreadMessageCount = 0;
    this.hasError = true;
  }

  private alert(text: string) {
    this.alertService.error(text);
  }

  refreshUnreadMessageCount() {
    this.loadUnreadMessageCount();
  }
}
